// base class to handle responses
// Api(url, dataHash)
//  .info(true)   # chow api message info via Toastify
//  .close(true)  # close SideDialog or any other dialog
//  .reload(true) # reload page using Turbo

class ApiResponse {
  constructor () {
    this.opt = {
      info: false,
      close: false,
      done: () => {},
      error: (r) => { alert('Error: ' + JSON.stringify(r, null, 2)) }
    }
  }

  // needs to return this to enable chain responses
  // Api(url).info(true).close(true)
  error() { this.opt.error = true; return this }
  info() { this.opt.info = true; return this }
  close() { this.opt.close = true; return this }
  reload(id) { this.opt.reload = id || true; return this }
  done(el) { this.opt.done = el; return this }

  resolveResponse(response, xhr) {
    this.response = response

    if (this.opt.info) {
      window.Toastify.show(response)
    }

    if(!response.error) {
      if (this.opt.close) {
        window.SideDialog.close()
      }

      if (this.opt.reload) {
        const path = this.opt.reload === true ? location.pathname : this.opt.reload

        if (path[0] === '#' || path == 'body') {
          // id given, refresh block
          $(path).reload()
        } else {
          Turbo.visit(path)
        }
      }

      this.opt.done(response)
    }
  }
}


function Api(path, params = {}) {
  const ar = new ApiResponse()

  const xhr = $.post(
    path,
    params,
    (r)=>ar.resolveResponse.bind(ar)(r, xhr)
  )

  return ar
}

window.Api = Api
